(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireb86c"];
var parcelRegister = parcelRequire.register;
parcelRegister("9eJ88", function(module, exports) {

$parcel$export(module.exports, "newsArchiveMixItUp", function () { return $dd5cc76f1d61f224$export$3ca3cdeaf3d52d05; });
// NewsArchive filter + pagination
// ==========================================

var $19YmI = parcelRequire("19YmI");

var $5QrDu = parcelRequire("5QrDu");

var $eqT6r = parcelRequire("eqT6r");
const $dd5cc76f1d61f224$var$newsArchiveEl = document.getElementById("NewsArchive");
const $dd5cc76f1d61f224$var$articlesContainerEl = document.getElementById("articlesContainer");
const $dd5cc76f1d61f224$var$paginationCurrentPageEl = document.querySelector(".pagination__current");
const $dd5cc76f1d61f224$var$paginationTotalPagesEl = document.querySelector(".pagination__total");
const $dd5cc76f1d61f224$var$paginationNextElements = document.querySelectorAll(".pagination__next");
const $dd5cc76f1d61f224$var$paginationPrevElements = document.querySelectorAll(".pagination__back");
const $dd5cc76f1d61f224$var$filterButtonElements = document.querySelectorAll(".filter-dropdown__list-item");
const $dd5cc76f1d61f224$export$3ca3cdeaf3d52d05 = ()=>{
    const createQueryObjectFromString = (str)=>{
        let query = {
            category: "",
            year: "",
            page: ""
        };
        let splitString = str.split("&");
        splitString.forEach((s)=>{
            if (s.includes("category")) query.category = s.split("=")[1];
            if (s.includes("year")) query.year = s.split("=")[1];
            if (s.includes("page")) query.page = s.split("=")[1];
        });
        return query;
    };
    const createSearchString = (query)=>{
        let str = "";
        if (document.querySelector('[data-filter-group="category"]')) str += query.category != "" ? "&category=" + query.category : "";
        if (document.querySelector('[data-filter-group="year"]')) str += query.year != "" ? "&year=" + query.year : "";
        // Page below is used for pagination in CompetitionCalendar
        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get("page");
        if (myParam != undefined) str += myParam != "" ? "&page=" + myParam : "";
        return str;
    };
    // Update search string when filters are toggled
    const updateSearchString = ()=>{
        let categoryFilter = document.querySelector(".filter__category");
        let categoryFilterItem = categoryFilter?.querySelector(".mixitup-control-active");
        let yearFilter = document.querySelector(".filter__year");
        let yearFilterItem = yearFilter?.querySelector(".mixitup-control-active");
        let categoryFilterString = "";
        if (categoryFilterItem != undefined && categoryFilterItem.getAttribute("data-label-clean") != null) categoryFilterString += categoryFilterItem.getAttribute("data-label-clean");
        let yearFilterString = "";
        if (yearFilterItem != undefined && yearFilterItem.getAttribute("data-label-clean") != null) yearFilterString += yearFilterItem.getAttribute("data-label-clean");
        // PageString is used for pagination in CompetitionCalendar
        let pageString = "";
        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get("page");
        if (myParam != undefined) pageString = myParam;
        let queryObject = {
            category: categoryFilterString,
            year: yearFilterString,
            page: pageString
        };
        let queryString = createSearchString(queryObject);
        if (queryString.match(/&/)) queryString = queryString.replace("&", "");
        window.history.replaceState({}, "", "?" + queryString);
    };
    //  Activate/set selected filters. Called when page loads
    //  @param archiveMixer - the instance of mixer
    const activateFilters = (mixer)=>{
        if (window.location.search.length > 1) {
            let locationSearch = window.location.search;
            let initialQuery = createQueryObjectFromString(locationSearch);
            if (mixer != null) {
                // Category
                let categoryQuery = initialQuery.category;
                if (document.querySelector('[data-filter-group="category"]') && categoryQuery != "") mixer.setFilterGroupSelectors("category", "." + categoryQuery);
                // Year
                let yearQuery = initialQuery.year;
                if (document.querySelector('[data-filter-group="year"]') && yearQuery != "") mixer.setFilterGroupSelectors("year", ".year-" + yearQuery);
                // Parse setFilterGroupSelectors above
                mixer.parseFilterGroups();
            }
        }
    };
    // Function that checks and updates relevant elements in regards to mixitup pagination data
    const updatePaginationElements = (mixer)=>{
        if (mixer != undefined) {
            mixer.paginate(1);
            setTimeout(()=>{
                let currentPage = mixer.getState().activePagination?.page;
                let totalCurrentPages = mixer.getState().totalPages;
                // if there are more pages than one, enable next navigation
                if (totalCurrentPages > 1) {
                    Array.from($dd5cc76f1d61f224$var$paginationNextElements).forEach((element)=>{
                        element.classList.remove("disabled");
                    });
                    updatePageCounter(mixer);
                }
                // if current filter is only 1 page, hide pagination
                if (totalCurrentPages == 1) {
                    Array.from($dd5cc76f1d61f224$var$paginationPrevElements).forEach((element)=>{
                        element.classList.add("disabled");
                    });
                    Array.from($dd5cc76f1d61f224$var$paginationNextElements).forEach((element)=>{
                        element.classList.add("disabled");
                    });
                    updatePageCounter(mixer);
                }
                // if current page is the first page, disable navigation
                if (currentPage == 1) Array.from($dd5cc76f1d61f224$var$paginationPrevElements).forEach((element)=>{
                    element.classList.add("disabled");
                });
                else Array.from($dd5cc76f1d61f224$var$paginationPrevElements).forEach((element)=>{
                    element.classList.remove("disabled");
                });
            }, 100);
        }
    };
    // NEXT PAGE FUNCTION
    const nextPageFunction = (mixer)=>{
        mixer.paginate("next").then(function(state) {
            let currentPage = mixer.getState().activePagination.page;
            let totalPages = mixer.getState().totalPages;
            if (currentPage == totalPages) Array.from($dd5cc76f1d61f224$var$paginationNextElements).forEach((element)=>{
                element.classList.add("disabled");
            });
            Array.from($dd5cc76f1d61f224$var$paginationPrevElements).forEach((element)=>{
                if (element.classList.contains("disabled")) element.classList.remove("disabled");
            });
        });
        updatePageCounter(mixer);
    };
    // PREVIOUS PAGE FUNCTION
    const prevPageFunction = (mixer)=>{
        mixer.paginate("prev").then(function(state) {
            let currentPage = mixer.getState().activePagination.page;
            let totalPages = mixer.getState().totalPages;
            if (currentPage == 1) Array.from($dd5cc76f1d61f224$var$paginationPrevElements).forEach((element)=>{
                element.classList.add("disabled");
            });
            Array.from($dd5cc76f1d61f224$var$paginationNextElements).forEach((element)=>{
                if (element.classList.contains("disabled")) element.classList.remove("disabled");
            });
        });
        updatePageCounter(mixer);
    };
    // Function to call onMixEnd
    const mixEndFunction = (state)=>{
        updateSearchString();
    };
    if ($dd5cc76f1d61f224$var$articlesContainerEl != undefined) {
        (0, (/*@__PURE__*/$parcel$interopDefault($19YmI))).use((0, (/*@__PURE__*/$parcel$interopDefault($5QrDu))));
        (0, (/*@__PURE__*/$parcel$interopDefault($19YmI))).use((0, (/*@__PURE__*/$parcel$interopDefault($eqT6r))));
        // If desktop show 7 pagers, else only 5
        let pagers = screen.width > 500 ? 7 : 5;
        var archiveMixer = (0, (/*@__PURE__*/$parcel$interopDefault($19YmI)))($dd5cc76f1d61f224$var$articlesContainerEl, {
            multifilter: {
                enable: true
            },
            pagination: {
                limit: 6,
                maxPagers: pagers
            },
            animation: {
                enable: false
            },
            callbacks: {
                onMixEnd: mixEndFunction
            },
            templates: {
                pagerPrev: '<button class="${classNames}" title="F\xf6reg\xe5ende sida" data-page="prev"><svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.828 12L15.778 16.95L14.364 18.364L8 12L14.364 5.63599L15.778 7.04999L10.828 12Z" fill="#09121F" /></svg>F\xf6reg\xe5ende</button>',
                pagerNext: '<button class="${classNames}" title="N\xe4sta sida" data-page="next">N\xe4sta<svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.1719 12L8.22192 7.04999L9.63592 5.63599L15.9999 12L9.63592 18.364L8.22192 16.95L13.1719 12Z" fill="#09121F" /></svg></button>'
            }
        });
        // PREVIOUS PAGE EVENT LISTENTER
        if ($dd5cc76f1d61f224$var$newsArchiveEl != undefined && $dd5cc76f1d61f224$var$paginationPrevElements != undefined && $dd5cc76f1d61f224$var$paginationNextElements != undefined) Array.from($dd5cc76f1d61f224$var$paginationPrevElements).forEach((element)=>{
            element.addEventListener("click", ()=>{
                prevPageFunction(archiveMixer);
            });
        });
        // NEXT PAGE EVENT LISTENTER
        if ($dd5cc76f1d61f224$var$newsArchiveEl != undefined && $dd5cc76f1d61f224$var$paginationNextElements != undefined && $dd5cc76f1d61f224$var$paginationPrevElements != undefined) Array.from($dd5cc76f1d61f224$var$paginationNextElements).forEach((element)=>{
            element.addEventListener("click", ()=>{
                nextPageFunction(archiveMixer);
            });
        });
        // Set filters on load
        activateFilters(archiveMixer);
        updatePaginationElements(archiveMixer);
    }
    // Function that updates page counter
    const updatePageCounter = (mixer)=>{
        if ($dd5cc76f1d61f224$var$paginationCurrentPageEl != undefined && $dd5cc76f1d61f224$var$paginationTotalPagesEl != undefined) {
            let currentPage = mixer.getState().activePagination.page;
            let totalCurrentPages = mixer.getState().totalPages;
            $dd5cc76f1d61f224$var$paginationCurrentPageEl.innerHTML = currentPage;
            $dd5cc76f1d61f224$var$paginationTotalPagesEl.innerHTML = totalCurrentPages;
        }
    };
    // Check pagination status on filter change
    if ($dd5cc76f1d61f224$var$filterButtonElements != undefined) Array.from($dd5cc76f1d61f224$var$filterButtonElements).forEach((element)=>{
        element.addEventListener("click", ()=>{
            updatePaginationElements(archiveMixer);
        });
    });
};

});

})();
//# sourceMappingURL=newsArchiveMixItUp.bb706f33.js.map
